function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M7.128 2h11.744c1.783 0 2.43.186 3.082.534.652.349 1.163.86 1.512 1.512.348.652.534 1.299.534 3.082v11.744c0 1.783-.186 2.43-.534 3.082a3.635 3.635 0 01-1.512 1.512c-.652.348-1.299.534-3.082.534H7.128c-1.783 0-2.43-.186-3.082-.534a3.635 3.635 0 01-1.512-1.512C2.186 21.302 2 20.655 2 18.872V7.128c0-1.783.186-2.43.534-3.082a3.635 3.635 0 011.512-1.512C4.698 2.186 5.345 2 7.128 2z",
  fill: "#E44D26"
}), React.createElement("path", {
  d: "M13 4h6.436c.892 0 1.215.093 1.54.267.327.174.583.43.757.756.174.326.267.65.267 1.54v12.873c0 .892-.093 1.215-.267 1.54-.174.327-.43.583-.756.757-.326.174-.65.267-1.54.267H13V4z",
  fill: "#F16529"
}), React.createElement("path", {
  d: "M4 11h1.4v1.322h1.289V11h1.399v4h-1.4v-1.333H5.412V15H4m5.937-2.667H8.702V11h3.875v1.333h-1.24V15h-1.4m3.255-4h1.466l.9 1.409.9-1.409h1.466v4h-1.399v-1.983l-.98 1.438-.979-1.438V15h-1.374m5.426-4h1.399v2.678H22V15h-3.382",
  fill: "#FFF"
}));

var SvgCustomHtml = function SvgCustomHtml(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 26 26"
  }, props), _ref);
};

export default SvgCustomHtml;